import PanelPopup from './PanelPopup';
import PanelPopupV2 from './PanelPopup.actionbar_phase_2';
import PanelPopupContainer from './PanelPopup.container';
import { withFeatureBranch } from '../../../redux/flags';
export default PanelPopupContainer(withFeatureBranch({ actionbar_phase_2: PanelPopupV2 })(PanelPopup));
//# sourceMappingURL=index.js.map